(function () {
  var STORAGE_ENTER = 'qo-show-newsletter-popup';
  var STORAGE_SUBSCRIBED = 'qo-newsletter-subscribed';
  var CLOSE_MS = 350;

  function init() {
    var popup = document.getElementById('CollectionEarlyAccessPopup');
    if (!popup) return;

    var forceOpen = Boolean(popup.querySelector('[data-collection-ea-force-open]'));
    var subscribed = Boolean(popup.querySelector('[data-collection-ea-subscribed]'));
    var cameFromEnter = sessionStorage.getItem(STORAGE_ENTER) === '1';

    sessionStorage.removeItem(STORAGE_ENTER);

    if (subscribed) {
      try {
        localStorage.setItem(STORAGE_SUBSCRIBED, '1');
      } catch (e) {}
    }

    var alreadySubscribed = false;
    try {
      alreadySubscribed = localStorage.getItem(STORAGE_SUBSCRIBED) === '1';
    } catch (e) {}

    var shouldOpen = forceOpen || (cameFromEnter && !alreadySubscribed);

    bind(popup);

    if (!shouldOpen) return;
    if (window.Shopify && window.Shopify.designMode && !forceOpen) return;

    var delay = document.querySelector('.qo-page-transition') ? 700 : 80;
    window.setTimeout(function () {
      openPopup(popup);
    }, delay);
  }

  function bind(popup) {
    popup.querySelectorAll('[data-collection-ea-close]').forEach(function (el) {
      el.addEventListener('click', function () {
        closePopup(popup);
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && popup.classList.contains('is-open')) {
        closePopup(popup);
      }
    });
  }

  function openPopup(popup) {
    popup.hidden = false;
    popup.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';

    requestAnimationFrame(function () {
      popup.classList.add('is-open');
      var field = popup.querySelector('.collection-ea-popup__email');
      if (typeof trapFocus === 'function') {
        trapFocus(popup, field || popup.querySelector('.collection-ea-popup__dialog'));
      } else if (field) {
        field.focus();
      }
    });
  }

  function closePopup(popup) {
    popup.classList.remove('is-open');
    popup.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';

    if (typeof removeTrapFocus === 'function') {
      removeTrapFocus();
    }

    window.setTimeout(function () {
      if (!popup.classList.contains('is-open')) popup.hidden = true;
    }, CLOSE_MS);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
